import { FC } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  IBulkActivateShiftTemplateProps,
  IInjectedDrawerProps,
} from "@ryde/shared";

import { BaseDrawer } from "../drawer";
import { FormDrawer } from "../form-drawer";
import { BulkPassengerActivateShiftTemplateForm } from "./bulk-passenger-activate-shift-template-form";
import { useBulkActivateShiftTemplate } from "./hooks/use-bulk-passenger-activate-shift-template";

export const BulkPassengerActivateShiftTemplateDrawer: FC<
  IBulkActivateShiftTemplateProps & IInjectedDrawerProps
> = ({ drawerNumber, onCloseDrawer }) => {
  const { t } = useTranslation();

  const { methods, handleActivate } = useBulkActivateShiftTemplate();

  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer} drawerNumber={drawerNumber}>
      <FormDrawer
        onCloseDrawer={onCloseDrawer}
        onCancelClick={onCloseDrawer}
        title={t("general.ACTIVATE_SHIFT_TEMPLATE")}
        onSaveClick={handleActivate}
        footerSaveLabel={t("general.ACTIVATE")}
        isSaveDisabled={!methods.formState.isValid}
      >
        <FormProvider {...methods}>
          <BulkPassengerActivateShiftTemplateForm />
        </FormProvider>
      </FormDrawer>
    </BaseDrawer>
  );
};
